// Quando o código de verificação NÃO chega, o que a tela diz.
//
// Desde que o backend parou de devolver o código no corpo da resposta (ele só
// vem em desenvolvimento), `enviado: false` deixou de ser um contratempo
// cosmético e passou a ser um FLUXO BLOQUEADO: não existe código para digitar,
// e nenhuma quantidade de espera na tela produz um. A tela precisa dizer isso.
//
// POR QUE UM MÓDULO PURO, e não texto solto nos componentes: a mesma
// classificação vale para o step-up (dois modais), para a troca de contato e
// para a de senha. Escrita em cada lugar, ela diverge — e o modo de divergir é
// alguém repetir a frase antiga, que prometia um código que não existe mais.
//
// REGRA DURA: o `motivo` NUNCA é renderizado cru. O backend já o traduz para um
// vocabulário fechado, mas se um valor novo aparecer aqui ele cai no genérico —
// nunca na tela. O `reason` interno do mailer carrega mensagem de exceção de
// socket SMTP (host, porta, timeout, resposta 5xx do servidor), e imprimir isso
// seria trocar o vazamento do código por um vazamento de topologia.

export interface BloqueioDeEnvio {
  /** O que aconteceu, na linguagem de quem está na tela. */
  causa: string;
  /** O que a pessoa faz agora. Uma causa sem próxima ação é um beco. */
  proximaAcao: string;
}

const POR_MOTIVO: Record<string, BloqueioDeEnvio> = {
  sem_destinatario: {
    causa: "Não há e-mail cadastrado nesta conta.",
    proximaAcao:
      "O código de verificação vai para o e-mail do cadastro. Peça a quem administra os acessos para cadastrá-lo e tente de novo.",
  },
  envio_nao_configurado: {
    causa: "O envio de e-mails não está configurado nesta plataforma.",
    proximaAcao:
      "Enquanto isso não for resolvido, ações que exigem código de confirmação ficam indisponíveis. Avise o suporte.",
  },
  falha_no_envio: {
    causa: "Não foi possível enviar o código agora.",
    proximaAcao:
      "Tente de novo em alguns instantes. Se continuar, avise o suporte informando o horário desta tentativa.",
  },
};

/** O genérico. Vale para motivo ausente E para motivo desconhecido — um valor
 *  que este mapa não conhece nunca chega à tela do jeito que veio. */
const DESCONHECIDO: BloqueioDeEnvio = POR_MOTIVO.falha_no_envio!;

export function mensagemDeBloqueio(motivo?: string): BloqueioDeEnvio {
  if (!motivo) return DESCONHECIDO;
  return POR_MOTIVO[motivo] ?? DESCONHECIDO;
}

/** As duas frases juntas, para onde só cabe uma string (um `setErro`). */
export function textoDeBloqueio(motivo?: string): string {
  const m = mensagemDeBloqueio(motivo);
  return `${m.causa} ${m.proximaAcao}`;
}
